module.exports = __webpack_public_path__ + "images/a1050a4fd0419219c1ff8ee30ef0f272.png";